const $$splitLoaderImporter = () => import('/app/apps/web/src/routes/_app/styles/index.tsx?tsr-split=loader');
import { lazyFn } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/_app/styles/")({
  loader: lazyFn($$splitLoaderImporter, 'loader')
});